import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "mackbe.cookieConsent.v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        // Defer slightly so it doesn't fight with hero entrance
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (choice) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, ts: Date.now() })
      );
    } catch (_) {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-[60] max-w-md"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie notice"
    >
      <div className="mk-card rounded-2xl p-5 md:p-6 shadow-2xl bg-[#0A1628]/95 backdrop-blur-xl">
        <div className="flex items-start gap-4">
          <div className="flex-1">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#00D4FF] font-medium">
              Cookies
            </div>
            <p className="mt-2 text-[14px] text-slate-300 leading-relaxed">
              We use a small number of cookies to keep this site running and
              understand how it's used. See our{" "}
              <a
                href="/cookies"
                className="mk-underline-link text-white"
                data-testid="cookie-banner-policy-link"
              >
                Cookie Notice
              </a>
              .
            </p>
          </div>
          <button
            onClick={() => handleChoice("dismissed")}
            className="shrink-0 inline-flex h-8 w-8 items-center justify-center rounded-full text-slate-400 hover:text-white hover:bg-white/5 transition-colors"
            aria-label="Dismiss cookie notice"
            data-testid="cookie-banner-close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-5 flex gap-2">
          <button
            onClick={() => handleChoice("rejected")}
            data-testid="cookie-banner-reject"
            className="mk-btn-secondary px-4 py-2.5 rounded-full text-[13px] font-semibold"
          >
            Essential only
          </button>
          <button
            onClick={() => handleChoice("accepted")}
            data-testid="cookie-banner-accept"
            className="mk-btn-primary px-5 py-2.5 rounded-full text-[13px] font-semibold flex-1"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
